import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ComicCard from '@/components/feature/ComicCard';
import { useParams } from 'react-router-dom';
import { getCategoryBySlug, getComicsByCategory, categories } from '@/mocks/comics';
import { Link } from 'react-router-dom';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = getCategoryBySlug(slug || 'shaonian');
  const comics = getComicsByCategory(slug || 'shaonian');

  const categoryName = category?.name || '漫画分类';

  const categoryJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${categoryName} - 073漫画网`,
    description: `073漫画网${categoryName}分类，提供${categoryName}在线免费阅读，海量${categoryName}资源每日更新。`,
    url: `http://tangcruises.com/category/${slug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '073漫画网',
      url: 'http://tangcruises.com/',
    },
  };

  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'http://tangcruises.com/',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: categoryName,
        item: `http://tangcruises.com/category/${slug}`,
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(categoryJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(breadcrumbJsonLd)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20 pb-10">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: categoryName },
              ]}
            />

            <div className="mt-6 mb-8">
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                {categoryName}
              </h1>
              <p className="text-sm text-foreground-500 mt-2">
                共找到 <strong className="text-primary-500">{comics.length}</strong> 部{categoryName}作品，073漫画网为您提供{categoryName}在线免费阅读
              </p>
            </div>

            <div className="flex flex-col lg:flex-row gap-8">
              <div className="flex-1">
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
                  {comics.map((comic) => (
                    <ComicCard
                      key={comic.id}
                      id={comic.id}
                      title={comic.title}
                      author={comic.author}
                      cover={comic.cover}
                      rating={comic.rating}
                      views={comic.views}
                      chapters={comic.chapters}
                      status={comic.status}
                      category={comic.category}
                      updatedAt={comic.updatedAt}
                      tags={comic.tags}
                    />
                  ))}
                </div>
                {comics.length === 0 && (
                  <div className="text-center py-20">
                    <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
                      <i className="ri-emotion-sad-line text-2xl text-foreground-400"></i>
                    </div>
                    <p className="text-foreground-500">该分类暂无漫画</p>
                  </div>
                )}
              </div>

              <aside className="lg:w-64 flex-shrink-0">
                <div className="bg-background-50 rounded-xl border border-background-200/70 p-5 sticky top-24">
                  <h3 className="font-heading text-sm font-bold text-foreground-900 mb-4">全部分类</h3>
                  <div className="flex flex-col gap-1">
                    {categories.map((cat) => (
                      <Link
                        key={cat.slug}
                        to={`/category/${cat.slug}`}
                        className={`flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors cursor-pointer ${
                          cat.slug === slug
                            ? 'bg-primary-50 text-primary-500 font-medium'
                            : 'text-foreground-600 hover:text-primary-500 hover:bg-background-100'
                        }`}
                      >
                        <div className="w-5 h-5 flex items-center justify-center">
                          <i className={`${cat.icon} text-sm`}></i>
                        </div>
                        <span className="whitespace-nowrap">{cat.name}</span>
                        <span className="ml-auto text-xs text-foreground-400">{cat.count}</span>
                      </Link>
                    ))}
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}